import { render, staticRenderFns } from "./ComparativoMensual.vue?vue&type=template&id=a5c7831e&"
import script from "./ComparativoMensual.vue?vue&type=script&lang=js&"
export * from "./ComparativoMensual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports